import "@/App.css";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { homeFor } from "@/components/shared";
import Landing from "@/pages/Landing";
import EmbedBooking from "@/pages/EmbedBooking";
import Login from "@/pages/Login";
import VetDashboard from "@/pages/vet/VetDashboard";
import ClienteDashboard from "@/pages/cliente/ClienteDashboard";
import { Cimitero, ScaricaApp } from "@/pages/PublicPages";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Agenda from "@/pages/admin/Agenda";
import Anagrafica from "@/pages/admin/Anagrafica";
import DdtArchive from "@/pages/admin/DdtArchive";
import DdtEditor from "@/pages/admin/DdtEditor";
import Cremazioni from "@/pages/admin/Cremazioni";
import Impianto from "@/pages/admin/Impianto";
import Riconsegne from "@/pages/admin/Riconsegne";
import Contabilita from "@/pages/admin/Contabilita";
import Impostazioni from "@/pages/admin/Impostazioni";
import Fatture from "@/pages/admin/Fatture";
import Partner from "@/pages/admin/Partner";
import Dipendenti from "@/pages/admin/Dipendenti";
import Automezzi from "@/pages/admin/Automezzi";
import AreaClienti from "@/pages/admin/AreaClienti";
import { Autorizzazioni, Ordini } from "@/pages/admin/Documenti";

const Protected = ({ roles, children }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#0D3B52]" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user.role === "admin" ? children : <Navigate to="/admin" replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/prenota" element={<EmbedBooking />} />
            <Route path="/cimitero" element={<Cimitero />} />
            <Route path="/app" element={<ScaricaApp />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/login" element={<Login />} />
            <Route path="/veterinario" element={<Protected roles={["vet"]}><VetDashboard /></Protected>} />
            <Route path="/cliente" element={<Protected roles={["cliente"]}><ClienteDashboard /></Protected>} />
            <Route path="/admin" element={<Protected roles={["admin", "dipendente"]}><AdminLayout /></Protected>}>
              <Route index element={<Overview />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="anagrafica" element={<Anagrafica />} />
              <Route path="ddt" element={<DdtArchive />} />
              <Route path="ddt-asl" element={<DdtArchive asl />} />
              <Route path="ddt/nuovo" element={<DdtEditor />} />
              <Route path="ddt/:id" element={<DdtEditor />} />
              <Route path="cremazioni" element={<Cremazioni />} />
              <Route path="impianto" element={<Impianto />} />
              <Route path="riconsegne" element={<Riconsegne />} />
              <Route path="partner" element={<Partner />} />
              <Route path="ordini" element={<Ordini />} />
              <Route path="clienti-app" element={<AreaClienti />} />
              <Route path="automezzi" element={<Automezzi />} />
              <Route path="autorizzazioni" element={<Autorizzazioni />} />
              <Route path="dipendenti" element={<Dipendenti />} />
              <Route path="contabilita" element={<AdminOnly><Contabilita /></AdminOnly>} />
              <Route path="fatture" element={<AdminOnly><Fatture /></AdminOnly>} />
              <Route path="impostazioni" element={<AdminOnly><Impostazioni /></AdminOnly>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
